/*
 * @Author: Wei Guojun 
 * @Date: 2021-04-09 09:51:53 
 * @Last Modified by: Wei Guojun
 * @Last Modified time: 2023-02-10 14:02:43
 */
import Vue from 'vue';
import Router from 'vue-router';
//重复点击报错设置
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router)
let router = new Router({
    mode: 'history',
    routes:[
        {
            path:'/',
            name:'layout',
            redirect: "/home",
            component:()=> import ('@/components/layout_main.vue'),
            meta:{
                title:'韵商宝-首页',
                requireAuth: true // 只要此字段为true，必须做鉴权处理
            },
            children:[
                {  
                    path:"home",
                    name:'home',
                    component:()=> import ('@/views/placeOrder/home.vue'),
                    meta:{
                        title:'韵商宝-首页',
                        requireAuth: true // 只要此字段为true，必须做鉴权处理
                    },
                },
                {  
                    path:"customer",
                    name:'customer',
                    component:()=> import ('@/views/placeOrder/customer.vue'),
                    meta:{
                        title:'韵商宝-代客下单',
                        requireAuth: true // 只要此字段为true，必须做鉴权处理
                    },
                },
                {  
                    path:"editBill",
                    name:'editBill',
                    component:()=> import ('@/views/placeOrder/editBill.vue'),
                    meta:{
                        title:'韵商宝-订单编辑',
                    },
                },
                {  
                    path:"electronicSheet",
                    name:'electronicSheet',
                    component:()=> import ('@/views/electronicSheet.vue'),
                    meta:{
                        title:'韵商宝-电子面单',
                    },
                },
                {  
                    path:"waitPrinted",
                    name:'waitPrinted',
                    component:()=> import ('@/views/oderList/waitPrinted.vue'),
                    meta:{
                        title:'韵商宝-待打印',
                        requireAuth: true // 只要此字段为true，必须做鉴权处理
                    },
                },
                {  
                    path:"printed",
                    name:'printed',
                    component:()=> import ('@/views/oderList/printed.vue'),
                    meta:{
                        title:'韵商宝-已打印',
                        requireAuth: true // 只要此字段为true，必须做鉴权处理
                    },
                },
                // {  
                //     path:"orders",
                //     name:'orders',
                //     component:()=> import ('@/views/oderList/orders.vue'),
                //     meta:{
                //         title:'韵商宝-运单',
                //         requireAuth: true // 只要此字段为true，必须做鉴权处理
                //     },
                // },
                {
                    path: "stopArea",
                    name: "stopArea",
                    component:()=> import ('@/views/stopArea.vue'),
                    meta: {
                      title: "韵商宝-停发区查询"
                    }
                },
                {
                    path: "setTemplate",
                    name: "setTemplate",
                    component:()=> import ('@/views/setTemplate.vue'),
                    meta: {
                      title: "韵商宝-打印设置"
                    }
                },
                {
                    path: "faceSheet",
                    name: "faceSheet",
                    component:()=> import ('@/views/faceSheet.vue'),
                    meta: {
                      title: "韵商宝-协议面单"
                    }
                },
                {
                    path: "addressMenu",
                    name: "addressMenu",
                    component:()=> import ('@/views/addressMenu.vue'),
                    meta: {
                      title: "韵商宝-地址管理"
                    }
                },
                {
                    path: "sheet",
                    name: "sheet",
                    component:()=> import ('@/views/sheet.vue'),
                    meta: {
                      title: "韵商宝-订单信息"
                    }
                },
                {
                    path: "peosonInfo",
                    name: "peosonInfo",
                    component:()=> import ('@/views/peosonInfo.vue'),
                    meta: {
                      title: "韵商宝-个人资料"
                    }
                },
                {
                    path: "forSign",
                    name: "forSign",
                    component:()=> import ('@/views/forSign.vue'),
                    meta: {
                      title: "韵商宝-签收统计"
                    }
                },
                {
                    path: "electronBill",
                    name: "electronBill",
                    component:()=> import ('@/views/electronBill.vue'),
                    meta: {
                      title: "韵商宝-电子面单"
                    }
                }
            ]
        },
        {  
            path:"/loading",
            name:'loading',
            component:()=> import ('@/views/preLoading.vue'),
            meta:{
                title:'韵商宝-加载中',
                requireAuth: true // 只要此字段为true，必须做鉴权处理
            },
        },
        {
            path: "/login",
            name: "login",
            component: ()=> import ('@/views/login/index'),
            meta: {
              title: "韵商宝-登录"
            }
        },
        {
            path: "/bindywy",
            name: "bindywy",
            component: ()=> import ('@/views/bindywy.vue'),
            meta: {
              title: "韵商宝-绑定业务员"
            }
        },
        {
            path: "/dataPerfect",
            name: "dataPerfect",
            component: ()=> import ('@/views/dataPerfect.vue'),
            meta: {
              title: "韵商宝-完善资料"
            }
        },
        //(url错误或不存在时)默认跳转
        // {
        //     path:"/404",
        //     name:'noFound',
        //     component:()=> import ('@/views/404.vue'),
        //     meta: {
        //       title: "404"
        //     }            
        // },
        // {
        //     path: "*",
        //     redirect: "/404",
        // }
    ]
})
export default router